import React from "react";
import "./Header.css";
import { ReactComponent as PostmanLogo } from "../assets/logo-light-full.svg";

const MinimalHeader = () => {
	return (
		<>
			<div className="mainHeader">
				<div className="firstContainerHero">
					<div className="firstContainer">
						<PostmanLogo className="firstPostmanLogo" />
					</div>
				</div>
			</div>
		</>
	);
};

export default MinimalHeader;
